export function ManualBuilderSection() {
  return (
    <section className="section-y section-x">
      <div className="max-w-7xl mx-auto flex flex-col-reverse lg:flex-row items-center gap-10 lg:gap-16">
        <div className="w-full lg:w-1/2">
          <div className="relative max-w-[280px] sm:max-w-[320px] lg:max-w-[340px] mx-auto group">
            <img
              alt="gymAhead workout detail with exercise list"
              className="w-full rounded-[2rem] sm:rounded-[2.5rem] shadow-2xl transition-transform duration-700 group-hover:scale-105"
              src="/3.png"
            />
          </div>
        </div>

        <div className="w-full lg:w-1/2 text-center lg:text-left">
          <span className="text-secondary font-headline font-bold tracking-widest text-xs uppercase mb-4 block">
            Build Your Session
          </span>
          <h2 className="font-headline font-bold text-3xl sm:text-4xl md:text-5xl mb-6 sm:mb-8 leading-tight">
            Plan the Workout You Want
          </h2>
          <p className="text-on-surface-variant text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed">
            Start from your own structure, choose the exercises that make sense, and keep the
            details clear before you step onto the floor. It is built for lifters who want control
            without spreadsheet friction.
          </p>
          <ul className="space-y-4 text-left max-w-lg mx-auto lg:mx-0">
            {[
              'Exercise-by-exercise planning',
              'Rest, reps, and notes in one place',
              'Balanced muscle-group coverage',
            ].map((feature) => (
              <li key={feature} className="flex items-start gap-3">
                <span className="material-symbols-outlined text-primary mt-0.5 shrink-0">
                  check_circle
                </span>
                <span className="text-on-surface font-semibold text-sm sm:text-base">{feature}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}
